export const cookie = {
    get(key) { 
        if(!key) return null
        const decodedCookie = decodeURIComponent(document.cookie);
        const result = decodedCookie.match(new RegExp(`${key}=([^;]+)`));

        return result && result[1]
    },

    set(key, value, expireday = 1, path = '/') {
        if(!key) return
        const now = new Date()
        now.setTime(
            now.getTime() + (expireday*24*60*60*1000)
        ) 
        document.cookie = `${key}=${value};expires=${now.toGMTString()};path=${path}`;
    },

    unset(key) {
        this.set(key, null, -1)
    },

    unsetAll() {
        const decodedCookie = decodeURIComponent(document.cookie);
        decodedCookie.split(";").forEach((cookie) => {
            const [key] = cookie.trim().split("=")
            this.set(key, null, -1)
        })
    }
}